const Footer = () => {
  return (
    <footer className="py-2 text-sm text-slate-400 ">
      Created with ❤️ by the folks at ankovar.com - {process.env.REACT_APP_VERSION}
    </footer>
  )
}
export default Footer
